
export function resolveWaiverIdForSave(
  formWaiverId: number | undefined | null,
  savedPatientId: number | undefined | null,
  waiverPatientId: number | undefined | null
): number {
  const waiverId = Number(formWaiverId) || 0;
  const patientId = Number(savedPatientId) || 0;
  const waiverOwnerId = Number(waiverPatientId) || 0;

  if (waiverId <= 0 || patientId <= 0) {
    return 0;
  }
  if (waiverOwnerId !== patientId) {
    return 0;
  }
  return waiverId;
}
